export default "__VITE_ASSET__CeiVSKY___"